export const createContestsEditionsStylesRequests = (client) => ({
    listContestsEditionStyles: async (params) => {
        const { data, meta, links } = await client.api.get("contests_edition_styles", {
            params: params,
        });
        return { data, meta, links };
    },
    getContestsEditionStyle: async (id, params) => {
        const { data } = await client.api.get(`contests_edition_styles/${id}`, {
            params: params,
        });
        return { data };
    },
    createContestsEditionStyle: async (payload) => {
        const { data } = await client.api.create("contests_edition_styles", payload);
        return { data };
    },
    updateContestsEditionStyle: async (payload) => {
        const { data } = await client.api.update("contests_edition_styles", payload);
        return { data };
    },
    deleteContestsEditionStyle: async (id) => {
        return client.api.remove("contests_edition_styles", id);
    },
    listContestsEditionStyleCategories: async (params) => {
        const { data, meta, links } = await client.api.get("contests_edition_style_categories", {
            params: params,
        });
        return {
            data,
            meta,
            links,
        };
    },
    findContestsEditionStyleCategory: async (params) => {
        const { data } = await client.api.get(`contests_edition_style_categories/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createContestsEditionStyleCategory: async (payload) => {
        const { data } = await client.api.create("contests_edition_style_categories", payload);
        return { data };
    },
    updateContestsEditionStyleCategory: async (payload) => {
        const { data } = await client.api.update(`contests_edition_style_categories/${payload?.id}`, payload);
        return { data };
    },
    deleteContestsEditionStyleCategory: async (id) => {
        return client.api.remove("contests_edition_style_categories", id);
    },
});
//# sourceMappingURL=index.js.map